import { DropdownOption } from '@keplerco/core';
import { FilteringSearchParams } from '../../../models/overmind/search-params';
import { SelectedFilterOption } from './analytics-filters.models';

export function removeFilterOption(searchParams: FilteringSearchParams, filter: SelectedFilterOption): FilteringSearchParams {
  const { filterType, slug } = filter;

  const newSearchParams: FilteringSearchParams = structuredClone(searchParams);

  const filterTypeKey = filterType as keyof FilteringSearchParams;
  if (!!filterTypeKey) {
    newSearchParams[filterTypeKey] = Array.isArray(newSearchParams[filterTypeKey]) ? newSearchParams[filterTypeKey]?.filter(option => option !== slug.replace(filterTypeKey, '')) : undefined;
  }

  return newSearchParams;
}

export function getSelectedFilters({
  searchParams,
  departmentOptions,
  teamOptions,
  roleOptions,
  skillOptions,
  countryOptions,
  statusOptions,
}: {
  searchParams: FilteringSearchParams;
  departmentOptions?: DropdownOption[];
  teamOptions?: DropdownOption[];
  roleOptions?: DropdownOption[];
  skillOptions?: DropdownOption[];
  countryOptions?: DropdownOption[];
  statusOptions?: DropdownOption[];
}): SelectedFilterOption[] {
  const selectedFilters: SelectedFilterOption[] = [];

  const filterMap = {
    departmentSlugs: { slugs: searchParams.departmentSlugs, options: departmentOptions },
    teamSlugs: { slugs: searchParams.teamSlugs, options: teamOptions },
    roleSlugs: { slugs: searchParams.roleSlugs, options: roleOptions },
    skillSlugs: { slugs: searchParams.skillSlugs, options: skillOptions },
    countryIds: { slugs: searchParams.countryIds, options: countryOptions },
    completionStatus: { slugs: searchParams.completionStatus, options: statusOptions },
  };

  Object.entries(filterMap).forEach(([filterType, { slugs, options }]) => {
    if (slugs && options) {
      const selectedSlugs = Array.isArray(slugs) ? (slugs as string[]) : [slugs as string];
      selectedSlugs.forEach(slug => {
        const option = options.find(option => option.value === slug);
        if (option && option.label) {
          selectedFilters.push({ name: option.label, filterType, slug: filterType.concat(slug) });
        }
      });
    }
  });

  return selectedFilters;
}
